import * as RoleActions from '../types/roleTypes';
import { RoleType } from 'redux/types/storeTypes';

const initialState: RoleType = {
  loading: false,
  error: undefined,
  items: []
};

const roleReducer = (state = initialState, action: { [key: string]: any }) => {

  switch (action.type) {

     case RoleActions.GET_ROLES_START:
      return {
        ...state,
        error: undefined,
        loading: true,
      };

    case RoleActions.GET_ROLES_SUCCESS:
      return {
        ...state,
        items: action.payload.roles,
        total: action.payload.total,
        limit: action.payload.limit,
        loading: false,
      };

    case RoleActions.GET_ROLES_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    default:
      return state;
  }
};

export default roleReducer;
